import { Typography, styled } from '@mui/material';

const InfoText = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 1.2rem;
  font-weight: 600;
  margin-top: 16px;

  text-align: center;
`;

export default InfoText;
